import PropTypes from "prop-types";
import React, { useState, useEffect } from "react";
import { Grid, Slider, Typography } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import spTheme from "../../spTheme";

const StyledSlider = withStyles({
  root: {
    height: 2,
    width: "90%",
    margin: "-6px 5% 1px 5%",
  },
  thumb: {
    height: 20,
    width: 20,
    backgroundColor: "#fff",
    border: `1px solid ${spTheme.palette.border.primary}`,
    marginTop: -6,
    marginLeft: -10,
    "&:active": { cursor: "grab" },
    "&:hover": { cursor: "grab" },
    "&:focus, &:hover, &$active": {},
  },
  valueLabel: {
    left: "calc(-50% + 2px)",
    "& *": {
      background: spTheme.palette.background.blue,
      color: "#000",
    },
  },
  track: {
    height: 8,
    borderRadius: 4,
    backgroundColor: spTheme.palette.background.blue,
  },
  rail: {
    height: 8,
    borderRadius: 4,
    backgroundColor: spTheme.palette.background.dark,
  },
  active: {},
})(Slider);

const SlidingRangeInput = ({
  label,
  unit,
  floor,
  ceil,
  onChangeFloor,
  onChangeCeil,
  min,
  max,
  showDivider,
}) => {
  const [slidingValues, setSlidingValues] = useState([floor || min, ceil || max]);
  const valueText = (value) => `${Math.round(value)}${unit}`;

  const handleSliding = (e, newValues) => {
    // this handler only changes the slider visually
    setSlidingValues(newValues);
  };

  const handleRangeChange = (e, newValues) => {
    // this handler changes the state (context)
    const [newFloor, newCeil] = newValues.map((val) => Math.round(val));
    onChangeFloor(newFloor);
    onChangeCeil(newCeil);
    setSlidingValues([newFloor, newCeil]);
  };

  useEffect(() => {
    setSlidingValues([floor || min, ceil || max]);
  }, [floor, ceil]);

  return (
    <Grid item xs={12} md={3}>
      <div style={{ marginTop: "16px", display: "flex" }}>
        {showDivider && (
          <div
            style={{
              position: "absolute",
              marginTop: "9px",
              marginLeft: "-9px",
              height: "48px",
              width: "1px",
              backgroundColor: "rgba(255,255,255,0.4)",
            }}
          />
        )}
        <div style={{ width: "100%" }}>
          <Typography
            id="range-slider"
            gutterBottom
            style={{
              width: "100%",
              textAlign: "left",
              fontSize: "10px",
              paddingLeft: "12px",
              paddingTop: "8px",
            }}
          >
            {label}
          </Typography>
          <StyledSlider
            value={slidingValues}
            onChange={handleSliding}
            onChangeCommitted={handleRangeChange}
            valueLabelDisplay="auto"
            aria-labelledby="range-slider"
            getAriaValueText={valueText}
            valueLabelFormat={valueText}
            step={0.01}
            min={min}
            max={max}
          />
        </div>
      </div>
    </Grid>
  );
};

SlidingRangeInput.propTypes = {
  label: PropTypes.string.isRequired,
  unit: PropTypes.string,
  floor: PropTypes.number,
  ceil: PropTypes.number,
  onChangeFloor: PropTypes.func.isRequired,
  onChangeCeil: PropTypes.func.isRequired,
  min: PropTypes.number,
  max: PropTypes.number,
  showDivider: PropTypes.bool,
};
SlidingRangeInput.defaultProps = {
  floor: undefined,
  ceil: undefined,
  unit: "",
  min: 0,
  max: 100,
  showDivider: false,
};

export default SlidingRangeInput;
